// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"248":"9a7857db8c1194dc","392":"dff855e9c1dae5ac","408":"759bee1bc99a3e49","482":"bdcb58c588cbc244"}[chunkId] + ".js";
};